import { AssistantMessage } from '@jupiter/shared';
import { api } from '../api';

export const assistantApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postAssistantMessage: builder.mutation<AssistantMessage, AssistantMessage>({
      query: (body) => ({
        url: 'assistant/message',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Assistant'],
      extraOptions: {
        retryCondition: (error, args, extraArgs) => {
          const { attempt } = extraArgs;
          if (attempt >= 5) {
            return false;
          }

          return error.status === 429 || error.status === 503;
        },
      },
    }),
  }),
  overrideExisting: false,
});

export const { usePostAssistantMessageMutation } = assistantApi;
